export type CustomerVatState = 'valid' | 'invalid' | 'unchecked';

export interface CustomerVatValidationTranslation {
  key:
    | 'customers:validation.validPolishNip'
    | 'customers:validation.invalidPolishNip'
    | 'customers:validation.validFormat'
    | 'customers:validation.invalidFormat';
}

/**
 * Canonical home for deriving a customer's VAT state from its stored fields.
 * Shared by the list, detail page, and customer form so the rule lives once.
 */
export function getVatState(customer: {
  taxId?: string | null;
  vatValidFormat?: boolean | null;
}): CustomerVatState {
  if (!customer.taxId || customer.vatValidFormat === null || customer.vatValidFormat === undefined) {
    return 'unchecked';
  }
  return customer.vatValidFormat ? 'valid' : 'invalid';
}

/**
 * Stored validation notes predate i18n and are English. User-facing surfaces
 * derive localized copy from the canonical result instead of rendering those
 * backend diagnostics verbatim.
 */
export function getVatValidationTranslation(validation: {
  valid: boolean;
  countryCode?: string | null;
}): CustomerVatValidationTranslation {
  if (validation.countryCode === 'PL') {
    return {
      key: validation.valid
        ? 'customers:validation.validPolishNip'
        : 'customers:validation.invalidPolishNip'
    };
  }

  return {
    key: validation.valid
      ? 'customers:validation.validFormat'
      : 'customers:validation.invalidFormat'
  };
}
